import { ProgressBar, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import pluralize from "pluralize";

export const DOCUMENT_STATUS_PROGRESS_VARIANTS = ["missing", "in_review", "completed"] as const;

export type DocumentStatusProgressVariant = (typeof DOCUMENT_STATUS_PROGRESS_VARIANTS)[number];

export interface DocumentsStatusProgressProps {
  variant: DocumentStatusProgressVariant;
  completedDocuments: number;
  totalDocuments: number;
}

function getTitle(props: DocumentsStatusProgressProps) {
  const { variant, totalDocuments, completedDocuments } = props;

  const remainingDocuments = totalDocuments - completedDocuments;

  if (variant === "missing") {
    return `Complete ${remainingDocuments} more mandatory ${pluralize(
      "document",
      remainingDocuments
    )} to book shifts`;
  }

  if (variant === "in_review") {
    return `All remaining mandatory documents are in review`;
  }

  return `Complete additional workplace specific documents to unlock more shifts.`;
}

export function DocumentsStatusProgress(props: DocumentsStatusProgressProps) {
  const { completedDocuments, totalDocuments, variant } = props;

  return (
    <Stack direction="column" spacing={6}>
      <Text bold variant="h4">
        {getTitle({
          completedDocuments,
          totalDocuments,
          variant,
        })}
      </Text>

      {variant !== "completed" && (
        <ProgressBar
          showCount
          completed={completedDocuments}
          total={totalDocuments}
          countSuffix="approved"
        />
      )}
    </Stack>
  );
}
